import { PLAN_TYPE } from '../../enums';

/**
 * 折扣类型
 */
export enum DISCOUNT_TYPE {
	FOREVER = 1,
	LIMITED_TIME = 2,
	VIRGIN = 3,
}

// 商品id是给支付用的，目前商品的定义是plan和produc一一对应的
export interface IPlanPackageGoods {
    /**
     * 商品ID
     */
    product_id: string;

    /**
     * 商品名称
     */
    product_name: string;

    /**
     * 用户选择的套餐（目前是选择的服务时长）
     */
    package: string;

    /**
     * 商品结算金额, e.g. 9000
     */
    amount_settle: number;

    /**
     * 商品原价 e.g.12000
     */
    amount: number;

    /**
     * 商品折扣率0.75
     */
    discount: number;
    discount_type: DISCOUNT_TYPE;

    /**
     * 商品描述 1年
     */
    desc: string;

    /**
     * 商品货币单位￥
     */
    currency: string;

    /**
     * 商品有效期（单位：月）
     */
    months: number;
}

export interface IPlanInfo {
    plan_id: PLAN_TYPE;
    account_quota: number;
    expire_time: number;
    expire_days: number;
    /**
     * 7 细分版本，与原来的teacher_status保持一致
     */
    teacher_status: number;

    /**
     * 判断用户 是否可以免费试用商用版
     */
    business_free_trial: 0 | 1;
}
